module.exports = __webpack_public_path__ + "static/media/three-stars-illustration.9b08ff7c.png";